@use '../@shared/global' as *;
@use '../@shared/card.mixin' as *;
@use '../@shared/mixins' as *;
@use '../tooltip/style.scss' as *;

@include kol-card;

@layer kol-component {
	.kol-dialog,
	.kol-modal {
		min-height: var(--a11y-min-size);
		padding: 0;
		border: 0;

		&::backdrop {
			background-color: rgb(0, 0, 0, 0.1);
		}
	}

	.kol-dialog__close-button,
	.kol-modal__close-button {
		position: absolute;
		top: to-rem(1);
		right: to-rem(1);
		z-index: 1;
	}
}
